export class Utils {
  public static deepCopy<T>(
    source: T,
    nullStrategy: (key: string, value: any) => any = this
      .replaceNullWithEmptyStringStrategy
  ): T {
    const stringify = nullStrategy
      ? JSON.stringify(source, nullStrategy)
      : JSON.stringify(source);

    return JSON.parse(stringify);
  }

  public static replaceNullWithEmptyStringStrategy(
    key: string,
    value: any
  ): any {
    return value === null ? '' : value;
  }

  public static isJsonDirty(
    object1: any,
    object2: any,
    nullStrategy: (key: string, value: any) => any = null
  ) {
    if (!nullStrategy) {
      nullStrategy = Utils.replaceNullWithEmptyStringStrategy;
    }

    const json1 = JSON.stringify(object1, nullStrategy);
    const json2 = JSON.stringify(object2, nullStrategy);

    return json1 !== json2;
  }

  public static changeKeyName = <T extends object>(
    obj: T,
    oldKey: keyof T,
    newKey: string
  ): T => {
    const { [oldKey]: value, ...rest } = obj; // Extract the value and the rest of the object
    return { ...rest, [newKey]: value } as T; // Add the new key and merge
  };

  
}

declare function structuredClone<T>(value: T): T;

export function deepCopyDate<T>(obj: T): T {
  // Modern browsers / Angular 16+ support structuredClone
  if (typeof structuredClone === 'function') {
    return structuredClone(obj);
  }

  // Fallback for older environments
  return restoreDates(JSON.parse(JSON.stringify(obj)));
}

export function restoreDates(obj: any): any {
  if (Array.isArray(obj)) {
    return obj.map(restoreDates);
  } else if (obj && typeof obj === 'object') {
    // Convert ISO string back to Date
    for (const key of Object.keys(obj)) {
      if (typeof obj[key] === 'string' && /^\d{4}-\d{2}-\d{2}T/.test(obj[key])) {
        obj[key] = new Date(obj[key]);
      } else {
        obj[key] = restoreDates(obj[key]);
      }
    }
  }
  return obj;
}